var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBuilding = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "36D386F0-102C-4B65-AA8D-A01F3012AF79") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,10 L22,10 L22,22 L13,22 L2,22 L2,2 L13,2 L13,10 Z M11,10 L11,4 L4,4 L4,20 L11,20 L11,10 Z M13,20 L20,20 L20,12 L13,12 L13,20 Z M5.0003,6.9998 L5.0003,4.9998 L7.0003,4.9998 L7.0003,6.9998 L5.0003,6.9998 Z M8.0003,6.9998 L8.0003,4.9998 L10.0003,4.9998 L10.0003,6.9998 L8.0003,6.9998 Z M5.0003,10.9998 L5.0003,8.9998 L7.0003,8.9998 L7.0003,10.9998 L5.0003,10.9998 Z M8.0003,10.9998 L8.0003,8.9998 L10.0003,8.9998 L10.0003,10.9998 L8.0003,10.9998 Z M5.0003,14.9998 L5.0003,12.9998 L7.0003,12.9998 L7.0003,14.9998 L5.0003,14.9998 Z M8.0003,14.9998 L8.0003,12.9998 L10.0003,12.9998 L10.0003,14.9998 L8.0003,14.9998 Z M5.0003,18.9998 L5.0003,16.9998 L7.0003,16.9998 L7.0003,18.9998 L5.0003,18.9998 Z M8.0003,18.9998 L8.0003,16.9998 L10.0003,16.9998 L10.0003,18.9998 L8.0003,18.9998 Z M14.0003,14.9998 L14.0003,12.9998 L16.0003,12.9998 L16.0003,14.9998 L14.0003,14.9998 Z M17.0003,14.9998 L17.0003,12.9998 L19.0003,12.9998 L19.0003,14.9998 L17.0003,14.9998 Z M14.0003,18.9998 L14.0003,16.9998 L16.0003,16.9998 L16.0003,18.9998 L14.0003,18.9998 Z M17.0003,18.9998 L17.0003,16.9998 L19.0003,16.9998 L19.0003,18.9998 L17.0003,18.9998 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Sixtbook_dashboard",
    transform: "translate(-22.000000, -567.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_building",
    transform: "translate(20.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBuilding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_building.0475dac5fc240d5521925c8d886d7759.svg";